import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/search.svg")